import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import useSWR from 'swr';
import { MaintenanceCostTypesDataGrid } from '../../components/datagrid/MaintenanceCostTypesDataGrid';
import { useBreadcrumbs } from '../../contexts/breadcrumbsContext';
import { PageContentWrapper } from '../../layouts/contentWrapper/PageContentWrapper';
import { MaintenanceCostType } from '../../types/maintenanceCost.types';
import { API_URL, fetcher } from '../../utils/apiUrl';
import { swrConfig } from '../Assets/AssetsEdit';

export function MaintenanceCostTypes() {
  const history = useHistory();
  const { setValue } = useBreadcrumbs();

  useEffect(() => {
    setValue({
      pageName: 'Maintenance cost types',
      steps: [{ name: 'Home', pathToCutCount: 1 }],
    });
    return () => {
      setValue(null);
    };
  }, []);

  const { data, error, mutate } = useSWR<MaintenanceCostType[]>(
    `${API_URL.MAINTENANCE_COST_TYPE_LIST}?visibleOnly=false`,
    fetcher,
    swrConfig,
  );

  const handleEditButton = (e): void => {
    history.push(`/maintenance-cost-types/edit/${e.row.data.id}`);
  };

  return (
    <PageContentWrapper error={error} loading={!data}>
      <MaintenanceCostTypesDataGrid data={data} handleEdit={handleEditButton} mutateData={mutate} />
    </PageContentWrapper>
  );
}
export default MaintenanceCostTypes;
